// extracted by mini-css-extract-plugin
module.exports = {"arrowContainer":"animatedArrow_arrowContainer___CL9b","arrow":"animatedArrow_arrow__3DHZc"};